import { combineReducers } from "redux";
import auth from "../services/auth";
import message from "./message";

export default combineReducers({
    auth,
    message,
});